import { Controller } from "@hotwired/stimulus"

// A menu that opens on click and closes on an outside click or Escape.
//
// Placement stays in the markup (an absolutely positioned panel inside a
// relative trigger), so this controller owns one thing: the open/closed state.
// Reach for `popover` instead when the surface opens on hover and has to
// escape a transformed ancestor — that one portals to <body>.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.closeOnOutside = (event) => {
      if (!this.element.contains(event.target)) this.close()
    }
    this.closeOnEscape = (event) => {
      if (event.key === "Escape") this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  toggle() {
    if (this.panelTarget.classList.contains("hidden")) this.open()
    else this.close()
  }

  open() {
    this.panelTarget.classList.remove("hidden")
    document.addEventListener("click", this.closeOnOutside)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  close() {
    this.panelTarget.classList.add("hidden")
    document.removeEventListener("click", this.closeOnOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }
}
